"use client";

import React from "react";
import { ShieldCheck, HeartPulse, Clock, Lock, Activity, Award, Siren } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const safetyFeatures = [{
  title: "Personalized 24/7 Caregiver Support",
  description: "With only five residents, our caregivers provide intimate, one-on-one attention day and night, ensuring a level of care that larger facilities cannot match.",
  icon: Clock
}, {
  title: "Family-Focused Emergency Protocols",
  description: "Our emergency response is personal. We maintain rigorous safety standards combined with immediate communication and a deep knowledge of each resident's history.",
  icon: Siren
}, {
  title: "Safe & Secure Home Environment",
  description: "Our Silver Spring residence is designed for both safety and serenity, providing a secure, wandering-protected environment that feels like a true home.",
  icon: Lock
}, {
  title: "Intimate Health Monitoring",
  description: "We provide dedicated medication management and regular health monitoring, working closely with families and doctors to ensure optimal well-being.",
  icon: Activity
}];
const certifications = [{
  label: "Personalized Care",
  icon: Award
}, {
  label: "Family Atmosphere",
  icon: ShieldCheck
}, {
  label: "Small Home Safety",
  icon: HeartPulse
}, {
  label: "Dedicated Supervision",
  icon: Clock
}];
export default function HealthSafety() {
  return <section id="health-safety" className="dark bg-background text-foreground py-20 px-6 md:py-32 md:px-12 lg:px-24 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-secondary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          
          {}
          <div className="lg:w-1/3 sticky top-32">
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 tracking-tight text-foreground leading-tight">
              Small Residential <br className="hidden lg:block" />
              <span className="text-secondary">Assisted Living Home</span>
            </h2>
            <p className="text-lg text-muted-foreground mb-10 leading-relaxed">
              Serving up to 5 residents in Silver Spring, Maryland, we provide personalized care in a warm, family-like environment where your loved one's health and safety are our highest priorities.
            </p>
            
            <div className="flex flex-wrap gap-3">
              {certifications.map((cert, i) => <Badge key={i} data-index={i} variant="secondary" className="py-1.5 px-4 text-sm bg-secondary/10 text-secondary hover:bg-secondary/20 border border-secondary/20 transition-colors">
                  <cert.icon className="w-4 h-4 mr-2" />
                  {cert.label}
                </Badge>)}
            </div>
          </div>

          {}
          <div className="lg:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-6">
            {safetyFeatures.map((feature, i) => <Card key={i} data-index={i} className="bg-card/50 backdrop-blur-sm border-border/50 hover:border-secondary/30 transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 group">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-xl bg-background flex items-center justify-center mb-4 border border-border group-hover:border-secondary/50 group-hover:bg-secondary/10 transition-colors">
                    <feature.icon className="w-6 h-6 text-secondary" />
                  </div>
                  <CardTitle className="text-xl font-semibold tracking-tight text-foreground">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>)}
          </div>

        </div>
      </div>
    </section>;
}